module.exports = __webpack_public_path__ + "static/media/turbine_electrical.ee38dcd8.png";